import Title from "./Title";
import CertificateCard from "./Cards/CertificateCard";
import certificates from "../Data/certificates.json";
import "../styles/style.css";
import "../styles/light-mode.css";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, EffectCoverflow, EffectCube, Autoplay } from 'swiper/modules';

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-coverflow";
import "swiper/css/effect-cube";

import { useState } from "react";
import Popup from "./Popup";

import { useTranslation } from "react-i18next"


export default function SectionFive() {


    const { t } = useTranslation();

    const [selectedCertificate, setSelectedCertificate] = useState(null);
    return (
        <section className="section sec-5">
            <Title id="certificate" title={t("title-certificate.text")} />

            <div className="container container-5">

                <h3 data-aos="fade-up" className="h3">{t("description-certificate.text")}</h3>

                <div data-aos="fade-left" className="desktop-swiper">
                    <Swiper
                        effect="coverflow"
                        centeredSlides={true}
                        slidesPerView={2}
                        loop={true}
                        grabCursor={true}

                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}

                        coverflowEffect={{
                            rotate: 35,
                            stretch: 0,
                            depth: 465,
                            modifier: 1,
                            scale: 0.9,
                            slideShadows: false,
                        }}

                        pagination={{
                            clickable: true,
                            dynamicBullets: true,
                        }}

                        modules={[Pagination, EffectCoverflow, Autoplay]}
                        className="mySwiper"
                    >
                        {certificates.map((certificate) => (
                            <SwiperSlide key={certificate.id}>
                                <CertificateCard
                                    image={certificate.image}
                                    title={certificate.title}
                                    onClick={() => setSelectedCertificate(certificate)}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>


                <div data-aos="fade-left" className=" mobile-swiper">
                    <Swiper
                        effect="cube"
                        centeredSlides={true}
                        slidesPerView={1}
                        loop={true}
                        grabCursor={true}

                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}

                        coverflowEffect={{
                            rotate: 35,
                            stretch: 0,
                            depth: 465,
                            modifier: 1,
                            scale: 0.9,
                            slideShadows: false,
                        }}

                        pagination={{
                            clickable: true,
                            dynamicBullets: true,
                        }}

                        modules={[Pagination, EffectCube, Autoplay]}
                        className="mySwiper"
                    >
                        {certificates.map((certificate) => (
                            <SwiperSlide key={certificate.id}>
                                <CertificateCard
                                    image={certificate.image}
                                    title={certificate.title}
                                    onClick={() => setSelectedCertificate(certificate)}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

                {selectedCertificate && (
                    <Popup
                        image={selectedCertificate.image}
                        title={selectedCertificate.title}
                        onClose={() => setSelectedCertificate(null)}
                    />
                )}

            </div>
        </section>
    );
}